/**
 * qq登录比较特殊，h5的message不能跨窗口，只能本窗口，但是，qq登录iframe形式总是失败
 * 所以，采用最原始的页面跳转方式：qqLogin页面 -> qq登录（上一个页面已经注销了） -> qqLogin页面
 */

import { randomHexString } from '@shared/utils/base/src/random.js'
import { stringifyQuery } from '@shared/utils/querystring'

import { urlThatWindow } from '@/common/resources.js'
import { CacheSessionSetState } from '@/common/cache.js'
import { loginAppType } from '@/common/const.js'

const APPIDQQ = {
  [loginAppType.wanmei]: '101946753',
  [loginAppType.keniu]: '101962557'
}

/** 当前中转页 */
const proxyUrl = {
  [loginAppType.wanmei]: 'https://www.777ppt.com/vip_login_proxy.html',
  [loginAppType.keniu]: 'https://o.keniu.com/vip_login_proxy.html'
}

/** 微信登录跳转中转页 */
const getQQProxyUrl = (loginType) => {
  return `${proxyUrl[loginType]}?origin=${urlThatWindow}/qqLogin`
}

export default class qqAuth {
  // 这里的loginType是指loginAppType，即可牛登录还是完美登录
  constructor (config = {}, loginType = loginAppType.wanmei) {
    const defaultConfig = {}
    this.loginAppType = loginType
    this.config = Object.assign(defaultConfig, config)
    this.state = randomHexString(16)
  }

  openAuthPage () {
    const queryObj = {
      client_id: APPIDQQ[this.loginAppType],
      response_type: 'code',
      redirect_uri: getQQProxyUrl(this.loginAppType),
      scope: 'get_user_info',
      // display: 'mobile',
      state: this.state
    }

    CacheSessionSetState(this.state)

    return `https://graph.qq.com/oauth2.0/authorize?${stringifyQuery(queryObj)}`
  }
}
